<template>
  <div id="detail">
    <bread :content="breadContent"></bread>
    <p class="Page-title">在线微课</p>
    <el-divider></el-divider>
    <div id="head">
      <video id="video" class="video-js vjs-default-skin vjs-big-play-centered"></video>
      <div id="word">
        <p class="title">{{showData.Title}}</p>
        <p class="second-title">授课教师：{{showData.Teacher}}</p>
        <p class="second-title" id="time">学时：{{showData.Classhour}}</p>
        <p class="title">课程详情</p>
        <span>{{showData.Description}}</span>
      </div>
    </div>
    <div id="content">
      <div id="list">
        <p class="list-head">课程目录</p>
        <div class="Chapter" v-for="(item,index1) in showData.CourseInfo" :key="index1">
          <p class="title">章节{{item.ChapterNum}}：{{item.ChapterName}}</p>
          <div class="class" :class="{'active':(index1==ifchoose[0]&&index2==ifchoose[1])}" @click="changeClass(index1,index2)" v-for="(classItem,index2) in item.LessonsInfo" :key="index2">
            <p>
              <span>课时{{classItem.LessonNum}}：</span>{{classItem.LessonName}}</p>
            <span>{{classItem.Duration}}</span>
          </div>
        </div>
      </div>

      <div id="experts">
        <div v-for="item in showData.Teachers">
          <p class="name">{{item.Name}}</p>
          <span>{{item.Intro}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bread from "@/components/bread";
import Api from "@/network.js";
export default {
  name: "detail",
  components: {
    bread
  },

  data() {
    return {
      ifchoose: [],
      player: {},
      breadContent: [
        { text: "首页", routerName: "index" },
        { text: "应急课堂", routerName: "knowledge" },
        { text: "在线微课", routerName: "" }
      ],
      options: {
        //是否显示控制栏，包括进度条，播放暂停按钮，音量调节等组件
        controls: true,
        width: 640,
        height: 360,
        //是否开启播放质量数据上报功能
        stat: true,
        // 播放前显示的视频画面，播放开始后自动移除。通常传入一个URL。
        // poster: '',
        preload: "metadata"
      },
      showData: {
        Title: "",
        Teacher: "",
        Teachers: [],
        Classhour: "",
        Description: "",
        CourseInfo: []
      }
    };
  },
  async mounted() {
    let res = await Api.emrClass.getVideoDetail(this.$route.query.id);
    hwplayerloaded(() => {
      this.showData = res;
      this.player = new HWPlayer("video", "hwplayer", this.options, function() {
        //播放器已经准备好了
        this.src("");
      });
      setTimeout(() => {
        // 自动选择第一个视频，否则无法点击播放
        document.querySelector(".Chapter .class").click();
      }, 0);
    });
  },
  destroyed() {
    this.player.dispose();
  },
  methods: {
    async changeClass(index1, index2) {
      this.ifchoose = [index1, index2];
      console.log(this.ifchoose);
      let id = this.showData.CourseInfo[index1].LessonsInfo[index2].VideoId;
      let Url = await this.$net.emrClass.getVideoUrl(id);
      this.player.src(Url);
    }
  }
};
</script>
<style lang="scss" scoped>
#detail {
  width: 70%;
  margin-left: 15%;
  margin-top: 80px;
  margin-bottom: 200px;
}
#video {
  width: 60% !important;
  height: 500px !important;
}
#head {
  display: flex;
  #word {
    margin-left: 70px;
    flex: 1;
  }
  span {
    flex-wrap: wrap;
    font-size: 16px;
    color: #c5c5c7;
    line-height: 32px;
  }
  .title {
    font-size: 32px;
    font-weight: 400;
    margin: 15px 0;
  }
  #time {
    margin-bottom: 40px;
  }
  .second-title {
    margin: 15px 0;
    font-size: 20px;
  }
}
#list {
  width: 80%;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(215, 215, 215, 1);
  border-radius: 3px;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.34901960784313);
  .list-head {
    font-size: 24px;
    padding: 15px;
  }
  .Chapter {
    .title {
      padding: 8px 15px;
      background-color: rgba(242, 242, 242, 1);
      font-size: 20px;
      color: #000000;
      opacity: 0.5;
      font-weight: 700;
    }
    .class {
      padding: 8px 15px;
      display: flex;
      font-size: 16px;
      cursor: pointer;
      justify-content: space-between;
      span {
        opacity: 0.5;
      }
    }
  }
}

#content {
  margin-top: 60px;
  margin-bottom: 200px;
  display: flex;
  justify-content: space-between;
  #experts {
    width: 15%;
    div {
      margin: 15px 0;
      padding: 15px;
      border-width: 1px;
      border-style: solid;
      border-color: rgba(215, 215, 215, 1);
      border-radius: 3px;
    }
    .name {
      font-size: 20px;
    }
    span {
      color: #c5c5c7;
    }
  }
}
.active {
  background: rgba(0, 135, 211, 1);
  color: white;
}
</style>
